import { request } from '@/utils/request'

// ==================== 类型定义 ====================

/** 登录类型 */
export enum LoginType {
  PWD = 'pwd',
  CODE = 'code',
  QR = 'qr'
}

/** 验证码场景 */
export enum AuthScene {
  Register = 1,
  Login = 2,
  Findback = 3,
  DeleteAccount = 4,
}

/** 验证码发送方式 */
export enum SendByType {
  Email = 1,
  SMS = 2,
}

/** 二维码状态 */
export enum QrCodeStatus {
  // Pending = 'pending',
  // Scanned = 'scanned',
  // Authed = 'authed',
  // Expired = 'expired'
  Pending = -1,
  Initial = 0,
  Scanned = 1,
  Authed = 2,
  Completed = 3,
  Expired = 4

}

/** 用户信息 */
export interface UserInfoModel {
  id: number
  username: string
  email?: string
  phone?: string
  avatar?: string
  nickname?: string
  roles: string[]
}

/** 登录/注册响应 */
export interface AuthResponse {
  token: string
  userInfo: UserInfoModel
}

/** 发送验证码响应 */
export interface SendCodeResponse {
  code?: string
  expireSeconds?: number
}

/** 二维码登录响应 */
export interface QrLoginResponse {
  qrCodeId: string
  qrCodeUrl: string
  expireSeconds?: number
}

/** 二维码状态响应 */
export interface QrStatusResponse {
  status: QrCodeStatus
  qrCodeId?: string
}

/** IP定位响应 */
export interface IpLocationResponse {
  countryCode: string
  country?: string
  ip?: string
}

/** 找回密码响应 */
export interface FindBackPwdResponse {
  isOk: boolean
  msg?: string
}

// ==================== API 方法 ====================

/** 获取客户端IP位置 */
export function getClientIpLocation(): Promise<IpLocationResponse> {
  return request<IpLocationResponse>({
    url: '/api/aaQrCodeSvcExt/getClientIpLocation',
    method: 'get'
  })
}

/** 发送验证码 */
export function sendAuthCode(
  authScene: AuthScene,
  sendBy: SendByType,
  sendTo: string
): Promise<SendCodeResponse> {
  return request<SendCodeResponse>({
    url: '/api/aaUserSvcExt/sendAuthCode',
    method: 'post',
    data: { authScene, sendBy, sendTo }
  })
}

/** 邮箱密码登录 */
export function loginWithEmail(loginNo: string, loginPwd: string): Promise<AuthResponse> {
  return request<AuthResponse>({
    url: '/api/aaUserSvcExt/login',
    method: 'post',
    data: { loginNo, loginPwd, loginType: 1, endpointType: 6 }
  })
}

/** 手机号登录 */
export function loginWithPhone(
  phoneNumber: string,
  loginType: LoginType,
  authCode?: string,
  loginPwd?: string
): Promise<AuthResponse> {
  const data: Record<string, string | number> = { phoneNumber, loginType }
  if (loginType === LoginType.CODE && authCode) {
    data.authCode = authCode
    data.loginType = 2
  } else if (loginType === LoginType.PWD && loginPwd) {
    data.loginPwd = loginPwd
    data.loginType = 1
  }
  data.endpointType = 6;
  return request<AuthResponse>({
    url: '/api/aaUserSvcExt/loginByPhone',
    method: 'post',
    data
  })
}

/** 邮箱注册 */
export function registerWithEmail(
  email: string,
  loginPwd: string,
  authCode: string
): Promise<AuthResponse> {
  return request<AuthResponse>({
    url: '/api/aaUserSvcExt/registerMail',
    method: 'post',
    data: { email, loginPwd, authCode }
  })
}

/** 手机号注册 */
export function registerWithPhone(
  phoneNumber: string,
  loginPwd: string,
  authCode: string
): Promise<AuthResponse> {
  return request<AuthResponse>({
    url: '/api/aaUserSvcExt/registerPhone',
    method: 'post',
    data: { phoneNumber, loginPwd, authCode }
  })
}

/** 创建登录二维码 */
export function createQrCode(clientType: string): Promise<QrLoginResponse> {
  return request<QrLoginResponse>({
    url: '/api/aaQrCodeSvcExt/Create',
    method: 'post',
    data: { clientType }
  })
}

/** 查询二维码状态 */
export function getQrCodeStatus(qrCodeId: string): Promise<QrStatusResponse> {
  return request<QrStatusResponse>({
    url: '/api/aaQrCodeSvcExt/Status',
    method: 'get',
    params: { qrCodeId }
  })
}

/** 完成二维码登录 */
export function completeQrCode(qrCodeId: string): Promise<{ loginToken: { accessToken: string } }> {
  return request<{ loginToken: { accessToken: string } }>({
    url: '/api/aaQrCodeSvcExt/Complete',
    method: 'get',
    params: { qrCodeId }
  })
}

/** 获取用户详情 */
export function getUserDetail(): Promise<UserInfoModel> {
  return request<UserInfoModel>({
    url: '/api/aaUserSvcExt/detail',
    method: 'get'
  })
}

export function refreshTokenReq(): Promise<AuthResponse> {
  return request<AuthResponse>({
    url: '/api/aaUserSvcExt/refreshToken',
    method: 'post',
  });
}

/** 找回密码 */
export function findBackPassword(
  email: string,
  authCode: string,
  loginPwd: string
): Promise<FindBackPwdResponse> {
  return request<FindBackPwdResponse>({
    url: '/api/aaUserSvcExt/findbackPassword',
    method: 'post',
    data: { email, authCode, loginPwd }
  })
}
